module.exports = __webpack_public_path__ + "./img/redTrashCan.ed675f639941aee0cd163393073ac067.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/redTrashCan.png
// module id = ./assets/images/redTrashCan.png
// module chunks = 0